import { render } from "./ProjectsListView.vue?vue&type=template&id=8740e3b6&scoped=true"
import script from "./ProjectsListView.vue?vue&type=script&lang=js"
export * from "./ProjectsListView.vue?vue&type=script&lang=js"

import "./ProjectsListView.vue?vue&type=style&index=0&id=8740e3b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8740e3b6"]])

export default __exports__